import { mergeClassNames } from '../utils/mergeClassNames.es.js';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { TooltipTrigger, TooltipTriggerStateContext, Tooltip as Tooltip$1 } from 'react-aria-components';
import { FocusableTrigger } from './FocusableTrigger.es.js';

const tooltip = "_tooltip_9uls1_1";
const styles = {
	tooltip: tooltip
};

const LINE_HEIGHT = 24;
const PADDING_Y = 4;
const SINGLE_LINE_HEIGHT = LINE_HEIGHT + PADDING_Y * 2;
const TOOLTIP_PLACEMENTS = [
  "bottom",
  "bottom left",
  "bottom right",
  "top",
  "top left",
  "top right",
  "left",
  "left top",
  "left bottom",
  "right",
  "right top",
  "right bottom"
];
const OFFSET_VALUES = {
  small: 4,
  medium: 8,
  large: 12
};
const getOffsetValue = (offset = "medium") => {
  if (typeof offset === "number") {
    return offset;
  }
  return OFFSET_VALUES[offset];
};
const Tooltip = ({ allowMultiline = false, children, className, content, isOpen, offset = "medium", onOpenChange, placement = "bottom", style }) => {
  return React.createElement(
    TooltipTrigger,
    { closeDelay: 200, delay: 200, isOpen, onOpenChange },
    children,
    React.createElement(TooltipContent, { allowMultiline, className, content, offset, placement, style })
  );
};
const TooltipContent = ({ allowMultiline, className, content, offset, placement, style }) => {
  var _a;
  const state = useContext(TooltipTriggerStateContext);
  const isOpen = (_a = state === null || state === void 0 ? void 0 : state.isOpen) !== null && _a !== void 0 ? _a : false;
  const [isMultiline, setIsMultiLine] = useState(allowMultiline);
  const tooltipRef = useRef(null);
  useEffect(() => {
    if (!allowMultiline) {
      setIsMultiLine(false);
    } else if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.getBoundingClientRect().height;
      const isMultiLine = tooltipHeight > SINGLE_LINE_HEIGHT;
      setIsMultiLine(isMultiLine);
    }
  }, [isOpen, allowMultiline]);
  return React.createElement(Tooltip$1, { className: (renderProps) => mergeClassNames([styles.tooltip, className], renderProps), "data-single-line": !allowMultiline, "data-multi-line": isMultiline, "data-zds": true, offset: getOffsetValue(offset), placement, ref: tooltipRef, style }, content);
};
Tooltip.FocusableTrigger = FocusableTrigger;

export { TOOLTIP_PLACEMENTS, Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.es.js.map
